<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  count: { type: Number, required: true },
});

const { t } = useI18n();

const displayCount = computed(() =>
  props.count > 9 ? t('CHAT_LIST.UNREAD_COUNT_OVERFLOW') : props.count
);
</script>

<template>
  <span
    v-if="count > 0"
    class="bg-green-500 rounded-full h-6 w-6 font-bold text-xs leading-none text-white flex items-center justify-center flex-shrink-0 shadow-sm"
  >
    {{ displayCount }}
  </span>
  <span v-else />
</template>
